import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const SnapchatDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>{'.snapchat9-16_svg__cls-1{fill:#212121}.snapchat9-16_svg__cls-2{fill:#fff}'}</style>
    </defs>
    <g id="snapchat9-16_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="snapchat9-16_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          className="snapchat9-16_svg__cls-1"
          d="M138.27 189.46V21.64A14.31 14.31 0 00124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v167.82z"
        />
        <path className="snapchat9-16_svg__cls-2" d="M34.59 34.79h34.37v3.94H34.59zM34.59 26.86h55.23v4.21H34.59z" />
        <path
          className="snapchat9-16_svg__cls-1"
          d="M6.28 189.9v89.34a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31V189.9z"
        />
        <rect className="snapchat9-16_svg__cls-2" x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <rect
          x={-44}
          y={96.35}
          width={232.32}
          height={132.01}
          rx={8.93}
          transform="rotate(90 72.16 162.35)"
          fill="#fffd49"
        />
        <path className="snapchat9-16_svg__cls-1" d="M60.59 267.85h23.14v3.94H60.59z" />
        <circle cx={21.24} cy={32.53} r={8.11} fill="#424242" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default SnapchatDevice916;
